(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-drawer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const drawer = document.getElementById('ContactDrawer');
    if (!drawer) return;
    const panel = drawer.querySelector('.contact-drawer__panel');
    const productSelect = drawer.querySelector('#ContactDrawerProduct');
    const tradeFields = drawer.querySelector('[data-trade-fields]');
    let lastFocus = null;

    function open(detail) {
      lastFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('contact-drawer-open');

      const heading = drawer.querySelector('#ContactDrawerTitle');
      if (heading) {
        heading.textContent = (detail && detail.title) || heading.dataset.defaultTitle || heading.textContent;
      }
      if (detail && detail.product && productSelect) {
        const opt = Array.from(productSelect.options).find(o => o.value === detail.product);
        if (opt) productSelect.value = detail.product;
      }

      const variantInput = drawer.querySelector('[data-contact-drawer-variant]');

      // The opener's data-variant is rendered once and goes stale: the theme's partial re-render swaps
      // only the inner <buy-buttons> element, not the whole block, so attributes on sibling buttons keep
      // their original values. The variant picker's JSON script IS re-rendered, so read the live value
      // from there and fall back to whatever the opener supplied.
      let variant = detail && detail.variant ? detail.variant : '';

      const liveVariant = document.querySelector('variant-picker script[data-variant]');
      if (liveVariant) {
        try {
          const parsed = JSON.parse(liveVariant.textContent || '{}');
          if (parsed && parsed.title) variant = parsed.title;
        } catch (e) { /* keep the opener's value */ }
      }

      if (variantInput) variantInput.value = variant;

      // Arriving from a configured product page, the piece is already known: state it and hide the
      // dropdown, so the panel continues the product journey rather than restarting it.
      const piece = drawer.querySelector('[data-contact-drawer-piece]');
      const pieceTitle = drawer.querySelector('[data-contact-drawer-piece-title]');
      const pieceVariant = drawer.querySelector('[data-contact-drawer-piece-variant]');
      const productField = drawer.querySelector('[data-contact-drawer-product-field]');
      const knownProduct = detail && detail.product ? detail.product : '';

      if (piece) {
        piece.hidden = !knownProduct;
        if (pieceTitle) pieceTitle.textContent = knownProduct;
        // "Medium / French Oak / Raw" reads better here as "Medium · French Oak · Raw"
        if (pieceVariant) pieceVariant.textContent = variant ? variant.split(' / ').join(' · ') : '';
      }

      if (productField) productField.hidden = !!knownProduct;

      // Show the tone alongside the words. The sample row already carries a photograph of the exact
      // timber/finish combination; failing that, fall back to the selected finish swatch in the picker.
      const pieceImage = drawer.querySelector('[data-contact-drawer-piece-image]');

      if (pieceImage) {
        let src = '';

        // The piece itself, not the sample chip - the gallery image is the one that says what they are
        // enquiring about. currentSrc picks whatever the responsive srcset actually loaded.
        const pieceShot = document.querySelector('.product-gallery img');
        if (pieceShot) src = pieceShot.currentSrc || pieceShot.src || '';

        pieceImage.src = src;
        pieceImage.hidden = !src;
        pieceImage.alt = src ? variant : '';
      }
      // Last, so it overrides the product-field handling above: a page that already knows the
      // reason for the enquiry presets the type and hides what is irrelevant to it.
      forceEnquiryType(detail && detail.enquiryType, detail && detail.enquiryLabel);

      setTimeout(() => panel.focus(), 50);
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('contact-drawer-open');
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function(e) {
      const opener = e.target.closest('[data-contact-drawer-open]');
      if (opener) {
        e.preventDefault();
        open({
          product: opener.dataset.product,
          variant: opener.dataset.variant,
          enquiryType: opener.dataset.enquiryType,
          enquiryLabel: opener.dataset.enquiryLabel,
          title: opener.dataset.drawerTitle
        });
        return;
      }
      if (e.target.closest('[data-contact-drawer-close]')) {
        e.preventDefault();
        close();
      }
    });

    // The bespoke page's two "Brief Our Design Team" buttons are section settings whose link is a
    // plain anchor, so they cannot carry data attributes. Treat that anchor as an opener rather
    // than making the visitor scroll to the button and click again.
    // Capture phase, and stopImmediatePropagation: preventDefault alone stops the browser's own
    // jump to the anchor, but not a theme handler that smooth-scrolls any in-page link without
    // checking defaultPrevented. Nothing else should see this click at all.
    document.addEventListener('click', function(e) {
      const anchor = e.target.closest('a[href$="#bespoke-form"], a[href$="#trade-application"]');
      if (!anchor) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const trade = (anchor.getAttribute('href') || '').endsWith('#trade-application');
      open(trade
        ? { enquiryType: 'trade-application', enquiryLabel: 'Trade account application', title: 'Apply for a trade account' }
        : { enquiryType: 'bespoke-project',   enquiryLabel: 'Bespoke project',           title: 'Tell us about your project' });
    }, true);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    document.addEventListener('contact-drawer:open', function(e) {
      open(e.detail || {});
    });

    drawer.addEventListener('change', function(e) {
      if (e.target.matches('[data-trade-toggle]')) {
        tradeFields.hidden = e.target.dataset.tradeToggle !== 'trade';
      }

      if (e.target.matches('[data-enquiry-type]')) {
        applyEnquiryType(e.target.dataset.enquiryType);
      }

      if (e.target.matches('[data-contact-preference]')) {
        revealFieldsFor(activeEnquiryType);
      }
    });

    // Reveal the fields that belong to this enquiry, and disable the rest. Disabling matters:
    // a hidden field that is still required would block submission with no visible cause.
    let activeEnquiryType = null;

    function callPreferred() {
      const call = drawer.querySelector('[data-contact-preference][value="A call"]');
      return !!(call && call.checked);
    }

    function revealFieldsFor(chosen) {
      activeEnquiryType = chosen;

      drawer.querySelectorAll('[data-when-enquiry]').forEach(function (field) {
        // A field can be gated twice: by the enquiry type, and by having asked for a call.
        const applies = field.dataset.whenEnquiry === chosen &&
                        (!field.hasAttribute('data-when-call') || callPreferred());
        field.hidden = !applies;
        field.querySelectorAll('input, select, textarea').forEach(function (input) {
          input.disabled = !applies;
        });
      });

      // A phone number is only worth insisting on if they have asked to be phoned. The label
      // carries the asterisk too, since every other required field in the panel is marked that way.
      const phoneField = drawer.querySelector('[data-generic-field="phone"] input');
      const phoneLabel = drawer.querySelector('[data-generic-field="phone"] span');
      if (phoneField) {
        const needed = chosen === 'bespoke-project' && callPreferred();
        phoneField.required = needed;
        if (phoneLabel) phoneLabel.textContent = needed ? 'Phone number *' : 'Phone number';
      }
    }

    function applyEnquiryType(chosen) {
      {
        revealFieldsFor(chosen);

        // The button should name the thing it is about to do
        const labels = {
          'request-a-quote': 'Request quote',
          'order-this-piece': 'Send order enquiry',
          'request-a-bespoke-alteration': 'Request alteration',
          'bespoke-project': 'Send project brief',
          'trade-application': 'Submit application',
          'ask-about-delivery': 'Ask about delivery',
          'something-else': 'Send question'
        };

        const submit = drawer.querySelector('[data-contact-drawer-submit]');
        if (submit) submit.textContent = labels[chosen] || 'Send enquiry';

        // Ask for what this kind of enquiry actually needs, rather than one generic prompt
        const placeholders = {
          'request-a-quote': 'Include any sizes, timbers, finishes or quantities you\u2019re considering.',
          'order-this-piece': 'Tell us your preferred quantity and any details we should know before preparing your order.',
          'request-a-bespoke-alteration': 'Tell us what you\u2019d like to change, including any dimensions, timber, finish or design details.',
          'bespoke-project': 'Describe the piece you have in mind, the room it is for, and anything that has inspired it.',
          'ask-about-delivery': 'Tell us where the piece will be delivered and anything you\u2019d like to know.',
          'something-else': 'How can we help?'
        };

        const message = drawer.querySelector('[data-contact-drawer-message]');
        if (message) {
          message.placeholder = placeholders[chosen] || 'Select an enquiry type above, then tell us how we can help.';
        }
      }
    }

    // Some pages already know why the visitor is here. Forcing the type hides the radio list,
    // disables it so its `required` cannot block submission, and sends the label via a hidden
    // input instead.
    function forceEnquiryType(typeKey, label) {
      const fieldset = drawer.querySelector('[data-enquiry-fieldset]');
      const radios = drawer.querySelectorAll('[data-enquiry-type]');
      const carrier = drawer.querySelector('[data-forced-enquiry]');

      if (!typeKey) {
        if (fieldset) fieldset.hidden = false;
        radios.forEach(function (r) { r.disabled = false; r.required = true; });
        if (carrier) { carrier.disabled = true; carrier.value = ''; }

        // The drawer is one shared instance, so anything hidden for a forced type must come back.
        const ct = drawer.querySelector('[data-customer-type-fieldset]');
        if (ct) {
          ct.hidden = false;
          ct.querySelectorAll('input').forEach(function (el) { el.disabled = false; el.required = true; });
        }
        if (tradeFields) {
          tradeFields.querySelectorAll('input, select, textarea').forEach(function (el) { el.disabled = false; });
        }
        drawer.querySelectorAll('[data-generic-field]').forEach(function (field) {
          field.hidden = false;
          field.querySelectorAll('input, select, textarea').forEach(function (el) { el.disabled = false; });
        });
        const tag = drawer.querySelector('[data-trade-tag]');
        if (tag) tag.disabled = true;

        // Conditional groups are only `hidden` in the markup, not disabled. Several carry
        // `required`, so leaving them enabled would block submission invisibly.
        revealFieldsFor(null);
        return;
      }

      if (fieldset) fieldset.hidden = true;
      radios.forEach(function (r) { r.disabled = true; r.required = false; });
      if (carrier) { carrier.disabled = false; carrier.value = label || typeKey; }

      // A bespoke brief is not about an existing piece, so the catalogue picker is only noise.
      const productField = drawer.querySelector('[data-contact-drawer-product-field]');
      if (productField && typeKey === 'bespoke-project') {
        productField.hidden = true;
        productField.querySelectorAll('select').forEach(function (el) { el.disabled = true; });
      }

      // The trade application carries its own name, phone, country and notes fields, using the
      // exact names the old page form used. Hide the drawer's generic equivalents so nothing is
      // asked twice, and switch on the hidden "trade programme" tag that form also sent.
      const isTrade = typeKey === 'trade-application';
      drawer.querySelectorAll('[data-generic-field]').forEach(function (field) {
        field.hidden = isTrade;
        field.querySelectorAll('input, select, textarea').forEach(function (el) { el.disabled = isTrade; });
      });

      const tradeTag = drawer.querySelector('[data-trade-tag]');
      if (tradeTag) tradeTag.disabled = !isTrade;

      if (productField && isTrade) {
        productField.hidden = true;
        productField.querySelectorAll('select').forEach(function (el) { el.disabled = true; });
      }

      // Nor is it the moment to ask whether someone is trade and to take their company details.
      // Disabling matters as well as hiding: the customer-type radios are required.
      const customerType = drawer.querySelector('[data-customer-type-fieldset]');
      if (customerType && (typeKey === 'bespoke-project' || isTrade)) {
        customerType.hidden = true;
        customerType.querySelectorAll('input').forEach(function (el) {
          el.disabled = true;
          el.required = false;
        });
      }

      if (tradeFields && (typeKey === 'bespoke-project' || isTrade)) {
        tradeFields.hidden = true;
        tradeFields.querySelectorAll('input, select, textarea').forEach(function (el) {
          el.disabled = true;
        });
      }

      applyEnquiryType(typeKey);
    }

    // Same reason, for the initial state before any enquiry type has been chosen.
    revealFieldsFor(null);

    // If submission succeeded (Liquid rendered the success message), reopen the drawer on load.
    if (drawer.querySelector('.contact-drawer__success')) {
      open({});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customise-drawer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const drawer = document.getElementById('CustomiseDrawer');
    if (!drawer) return;
    const panel = drawer.querySelector('.customise-drawer__panel');
    const productSelect = drawer.querySelector('#CustomiseDrawerProduct');
    const variantInput = drawer.querySelector('#CustomiseDrawerVariant');
    const variantIdInput = drawer.querySelector('#CustomiseDrawerVariantId');
    const pageUrlInput = drawer.querySelector('#CustomiseDrawerPageUrl');
    const prefillHint = drawer.querySelector('[data-prefill-hint]');
    let lastFocus = null;

    function getLiveVariant() {
      // 1. Try the URL ?variant=ID (Shopify updates this when a customer picks a variant)
      const params = new URLSearchParams(location.search);
      const urlVariantId = params.get('variant');

      // 2. Try the product form's hidden id input (most reliable for current selection)
      const formIdInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const formVariantId = formIdInput ? formIdInput.value : null;

      const liveId = formVariantId || urlVariantId;

      // 3. Try to derive a human-readable title from the variant picker.
      // Read the label text associated with each checked input, never the raw value
      // (the value is usually a variant ID, e.g. "5705183854931").
      let liveTitle = '';
      const picker = document.querySelector('variant-picker, [is="variant-picker"]') || document;
      const parts = [];
      picker.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(el => {
        let label = '';
        if (el.id) {
          const l = document.querySelector('label[for="' + el.id + '"]');
          if (l) label = l.textContent.trim();
        }
        if (!label) {
          const wrapping = el.closest('label');
          if (wrapping) label = wrapping.textContent.trim();
        }
        if (!label) label = el.dataset.optionValue || el.getAttribute('aria-label') || '';
        // Final fallback: only use value if it isn't purely numeric (which would be a variant ID)
        if (!label && el.value && !/^\d+$/.test(el.value)) label = el.value.trim();
        if (label) parts.push(label);
      });
      picker.querySelectorAll('select').forEach(el => {
        if (el.selectedOptions[0]) {
          const text = el.selectedOptions[0].text.trim();
          if (text && !/^\d+$/.test(text)) parts.push(text);
        }
      });
      liveTitle = parts.filter(Boolean).join(' / ');

      return { id: liveId, title: liveTitle };
    }

    function open(detail) {
      lastFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('customise-drawer-open');

      const live = getLiveVariant();

      let prefilled = false;
      if (detail && detail.product && productSelect) {
        const opt = Array.from(productSelect.options).find(o => o.value === detail.product);
        if (opt) {
          productSelect.value = detail.product;
          prefilled = true;
        }
      }
      if (variantInput) {
        const v = live.title || (detail && detail.variant) || '';
        variantInput.value = (v && v !== 'Default Title') ? v : '';
      }
      if (variantIdInput) {
        variantIdInput.value = live.id || (detail && detail.variantId) || '';
      }
      if (pageUrlInput) {
        pageUrlInput.value = (detail && detail.pageUrl) ? detail.pageUrl : (location.pathname + location.search);
      }
      if (prefillHint) prefillHint.hidden = !prefilled;

      setTimeout(() => panel.focus(), 50);
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('customise-drawer-open');
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function(e) {
      const opener = e.target.closest('[data-customise-drawer-open]');
      if (opener) {
        e.preventDefault();
        if (opener.tagName === 'DETAILS') opener.removeAttribute('open');
        // Release focus so the brown :focus-visible state doesn't latch
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        open({
          product: opener.dataset.product,
          variant: opener.dataset.variant,
          variantId: opener.dataset.variantId,
          pageUrl: opener.dataset.pageUrl
        });
        return;
      }
      if (e.target.closest('[data-customise-drawer-close]')) {
        e.preventDefault();
        close();
      }
    });

    // Prevent native <details> toggle on the trigger and handle keyboard activation
    document.querySelectorAll('details.customise-trigger').forEach(function(d) {
      d.addEventListener('toggle', function() { if (d.open) d.removeAttribute('open'); });
      const summary = d.querySelector('summary');
      if (summary) {
        summary.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open({
              product: d.dataset.product,
              variant: d.dataset.variant,
              variantId: d.dataset.variantId,
              pageUrl: d.dataset.pageUrl
            });
          }
        });
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    document.addEventListener('customise-drawer:open', function(e) {
      open(e.detail || {});
    });

    if (drawer.querySelector('.customise-drawer__success')) {
      open({});
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
